import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import ConfigManager from '../../vendor_core/core/src/managers/ConfigManager';
import ILocalConfig from '../../vendor_core/core/src/managers/contracts/configurations/ILocalConfig';

class LocalConfig implements ILocalConfig {
    type: ConfigurationTypes = ConfigurationTypes.LOCAL;

    overwritePatterns: { overwriteString: string; pattern: () => string; }[] = [
        {
            overwriteString: "rtp",
            pattern: () => ConfigManager.getConfig(ConfigurationTypes.GAME).getRTP(false).toString()
        },
        {
            overwriteString: "rtp_feature",
            pattern: () => ConfigManager.getConfig(ConfigurationTypes.GAME).getRTP(true).toString()
        }
    ];
}

export default new LocalConfig()
